/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Web Dispatcher - spring-backend
 * API documentation for developers
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EmployeeGroupAssignmentJSON,
  EmployeeGroupJSON,
  EmploymentCertificateJSON,
  ErrorDetails,
  ExportNetvisorParams,
  ExportProcountorParams,
  ExportSeveraParams,
  GetCompanyBalancesParams,
  ImportEmployeesRequestJSON,
  ImportEmployeesResponseJSON,
  ImportNetvisorParams,
  ImportProcountorParams,
  ImportPsaParams,
  ListProcountorParams,
  ModifyPersonVacationBalanceJSON,
  ModifySalaryTypeSupplementMappingJSON,
  PersonDetailsSalary,
  PersonDetailsSalaryJSON,
  PersonEmploymentPeriodsJSON,
  PersonJSON,
  PersonNumberExistsResultJSON,
  PersonSearchResponseJSON,
  PersonSummaryJSON,
  PersonTeamSummaryJSON,
  PersonVacationBalanceJSON,
  ProcountorVersionCheckJSON,
  SalaryTypeSupplementMappingJSON,
  SalaryTypeSupplementMappingLabelJSON,
  SocSecExistsResultJSON,
  TeamAssignmentJSON,
  TeamJSON,
  TeamMemberHRJSON
} from '../../model';

import { useCustomInstance } from '../../mutator/use-custom-instance.ts';
import type { ErrorType , BodyType } from '../../mutator/use-custom-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Updates multiple vacation balances at once
 * @summary Batch update vacation balances
 */
export const batchUpdateBalances = (
    modifyPersonVacationBalanceJSON: BodyType<ModifyPersonVacationBalanceJSON[]>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/vacation-balances/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modifyPersonVacationBalanceJSON, signal
    },
      options);
    }



export const getBatchUpdateBalancesMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchUpdateBalances>>, TError,{data: BodyType<ModifyPersonVacationBalanceJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof batchUpdateBalances>>, TError,{data: BodyType<ModifyPersonVacationBalanceJSON[]>}, TContext> => {

const mutationKey = ['batchUpdateBalances'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchUpdateBalances>>, {data: BodyType<ModifyPersonVacationBalanceJSON[]>}> = (props) => {
          const {data} = props ?? {};

          return  batchUpdateBalances(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BatchUpdateBalancesMutationResult = NonNullable<Awaited<ReturnType<typeof batchUpdateBalances>>>
    export type BatchUpdateBalancesMutationBody = BodyType<ModifyPersonVacationBalanceJSON[]>
    export type BatchUpdateBalancesMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Batch update vacation balances
 */
export const useBatchUpdateBalances = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchUpdateBalances>>, TError,{data: BodyType<ModifyPersonVacationBalanceJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchUpdateBalances>>,
        TError,
        {data: BodyType<ModifyPersonVacationBalanceJSON[]>},
        TContext
      > => {
      return useMutation(getBatchUpdateBalancesMutationOptions(options), queryClient);
    }
    /**
 * @summary Get team details
 */
export const getTeam = (
    id: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/teams/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetTeamQueryKey = (id: number,) => {
    return [
    `/api/v1/rest/teams/${id}`
    ] as const;
    }


export const getGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorDetails>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeam>>> = ({ signal }) => getTeam(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getTeam>>>
export type GetTeamQueryError = ErrorType<ErrorDetails>


export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorDetails>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorDetails>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorDetails>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get team details
 */

export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorDetails>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update an existing team
 */
export const updateTeam = (
    id: number,
    teamJSON: BodyType<TeamJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/teams/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: teamJSON, signal
    },
      options);
    }



export const getUpdateTeamMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{id: number;data: BodyType<TeamJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{id: number;data: BodyType<TeamJSON>}, TContext> => {

const mutationKey = ['updateTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeam>>, {id: number;data: BodyType<TeamJSON>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTeam(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeam>>>
    export type UpdateTeamMutationBody = BodyType<TeamJSON>
    export type UpdateTeamMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Update an existing team
 */
export const useUpdateTeam = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{id: number;data: BodyType<TeamJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTeam>>,
        TError,
        {id: number;data: BodyType<TeamJSON>},
        TContext
      > => {
      return useMutation(getUpdateTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete a team
 */
export const deleteTeam = (
    id: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/teams/${id}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteTeamMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeam>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTeam(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>

    export type DeleteTeamMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Delete a team
 */
export const useDeleteTeam = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeam>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTeamMutationOptions(options), queryClient);
    }
    /**
 * Updates multiple HR supplement mappings in a single request.
 * @summary Batch update salary type supplement mappings
 */
export const batchUpdateSalaryTypeSupplementMapping = (
    modifySalaryTypeSupplementMappingJSON: BodyType<ModifySalaryTypeSupplementMappingJSON[]>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<SalaryTypeSupplementMappingJSON[]>(
      {url: `/api/v1/rest/salary-mapping/supplements/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modifySalaryTypeSupplementMappingJSON, signal
    },
      options);
    }



export const getBatchUpdateSalaryTypeSupplementMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchUpdateSalaryTypeSupplementMapping>>, TError,{data: BodyType<ModifySalaryTypeSupplementMappingJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof batchUpdateSalaryTypeSupplementMapping>>, TError,{data: BodyType<ModifySalaryTypeSupplementMappingJSON[]>}, TContext> => {

const mutationKey = ['batchUpdateSalaryTypeSupplementMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchUpdateSalaryTypeSupplementMapping>>, {data: BodyType<ModifySalaryTypeSupplementMappingJSON[]>}> = (props) => {
          const {data} = props ?? {};

          return  batchUpdateSalaryTypeSupplementMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BatchUpdateSalaryTypeSupplementMappingMutationResult = NonNullable<Awaited<ReturnType<typeof batchUpdateSalaryTypeSupplementMapping>>>
    export type BatchUpdateSalaryTypeSupplementMappingMutationBody = BodyType<ModifySalaryTypeSupplementMappingJSON[]>
    export type BatchUpdateSalaryTypeSupplementMappingMutationError = ErrorType<unknown>

    /**
 * @summary Batch update salary type supplement mappings
 */
export const useBatchUpdateSalaryTypeSupplementMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchUpdateSalaryTypeSupplementMapping>>, TError,{data: BodyType<ModifySalaryTypeSupplementMappingJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchUpdateSalaryTypeSupplementMapping>>,
        TError,
        {data: BodyType<ModifySalaryTypeSupplementMappingJSON[]>},
        TContext
      > => {
      return useMutation(getBatchUpdateSalaryTypeSupplementMappingMutationOptions(options), queryClient);
    }
    /**
 * Replaces the current team assignments for a specific person
 * @summary Update teams assigned to a person
 */
export const updatePersonTeams = (
    personId: number,
    teamAssignmentJSON: BodyType<TeamAssignmentJSON[]>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/persons/${personId}/teams`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: teamAssignmentJSON, signal
    },
      options);
    }



export const getUpdatePersonTeamsMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonTeams>>, TError,{personId: number;data: BodyType<TeamAssignmentJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePersonTeams>>, TError,{personId: number;data: BodyType<TeamAssignmentJSON[]>}, TContext> => {

const mutationKey = ['updatePersonTeams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePersonTeams>>, {personId: number;data: BodyType<TeamAssignmentJSON[]>}> = (props) => {
          const {personId,data} = props ?? {};

          return  updatePersonTeams(personId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePersonTeamsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePersonTeams>>>
    export type UpdatePersonTeamsMutationBody = BodyType<TeamAssignmentJSON[]>
    export type UpdatePersonTeamsMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Update teams assigned to a person
 */
export const useUpdatePersonTeams = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonTeams>>, TError,{personId: number;data: BodyType<TeamAssignmentJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePersonTeams>>,
        TError,
        {personId: number;data: BodyType<TeamAssignmentJSON[]>},
        TContext
      > => {
      return useMutation(getUpdatePersonTeamsMutationOptions(options), queryClient);
    }
    /**
 * @summary Get a person's assigned employee group
 */
export const getPersonEmployeeGroup = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/persons/${personId}/employee-group`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonEmployeeGroupQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/persons/${personId}/employee-group`
    ] as const;
    }


export const getGetPersonEmployeeGroupQueryOptions = <TData = Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonEmployeeGroupQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonEmployeeGroup>>> = ({ signal }) => getPersonEmployeeGroup(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonEmployeeGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonEmployeeGroup>>>
export type GetPersonEmployeeGroupQueryError = ErrorType<ErrorDetails>


export function useGetPersonEmployeeGroup<TData = Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonEmployeeGroup>>,
          TError,
          Awaited<ReturnType<typeof getPersonEmployeeGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonEmployeeGroup<TData = Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonEmployeeGroup>>,
          TError,
          Awaited<ReturnType<typeof getPersonEmployeeGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonEmployeeGroup<TData = Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a person's assigned employee group
 */

export function useGetPersonEmployeeGroup<TData = Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmployeeGroup>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonEmployeeGroupQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Assign a person to an employee group
 */
export const assignPersonToEmployeeGroup = (
    personId: number,
    employeeGroupAssignmentJSON: BodyType<EmployeeGroupAssignmentJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/persons/${personId}/employee-group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: employeeGroupAssignmentJSON, signal
    },
      options);
    }



export const getAssignPersonToEmployeeGroupMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignPersonToEmployeeGroup>>, TError,{personId: number;data: BodyType<EmployeeGroupAssignmentJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assignPersonToEmployeeGroup>>, TError,{personId: number;data: BodyType<EmployeeGroupAssignmentJSON>}, TContext> => {

const mutationKey = ['assignPersonToEmployeeGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignPersonToEmployeeGroup>>, {personId: number;data: BodyType<EmployeeGroupAssignmentJSON>}> = (props) => {
          const {personId,data} = props ?? {};

          return  assignPersonToEmployeeGroup(personId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignPersonToEmployeeGroupMutationResult = NonNullable<Awaited<ReturnType<typeof assignPersonToEmployeeGroup>>>
    export type AssignPersonToEmployeeGroupMutationBody = BodyType<EmployeeGroupAssignmentJSON>
    export type AssignPersonToEmployeeGroupMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Assign a person to an employee group
 */
export const useAssignPersonToEmployeeGroup = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignPersonToEmployeeGroup>>, TError,{personId: number;data: BodyType<EmployeeGroupAssignmentJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignPersonToEmployeeGroup>>,
        TError,
        {personId: number;data: BodyType<EmployeeGroupAssignmentJSON>},
        TContext
      > => {
      return useMutation(getAssignPersonToEmployeeGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove a person from their employee group
 */
export const unassignPersonFromEmployeeGroup = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/persons/${personId}/employee-group`, method: 'DELETE', signal
    },
      options);
    }



export const getUnassignPersonFromEmployeeGroupMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignPersonFromEmployeeGroup>>, TError,{personId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignPersonFromEmployeeGroup>>, TError,{personId: number}, TContext> => {

const mutationKey = ['unassignPersonFromEmployeeGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignPersonFromEmployeeGroup>>, {personId: number}> = (props) => {
          const {personId} = props ?? {};

          return  unassignPersonFromEmployeeGroup(personId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignPersonFromEmployeeGroupMutationResult = NonNullable<Awaited<ReturnType<typeof unassignPersonFromEmployeeGroup>>>

    export type UnassignPersonFromEmployeeGroupMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Remove a person from their employee group
 */
export const useUnassignPersonFromEmployeeGroup = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignPersonFromEmployeeGroup>>, TError,{personId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unassignPersonFromEmployeeGroup>>,
        TError,
        {personId: number},
        TContext
      > => {
      return useMutation(getUnassignPersonFromEmployeeGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Get single employee group with members
 */
export const getEmployeeGroup = (
    id: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/employee-groups/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetEmployeeGroupQueryKey = (id: number,) => {
    return [
    `/api/v1/rest/employee-groups/${id}`
    ] as const;
    }


export const getGetEmployeeGroupQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeGroup>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeGroupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeGroup>>> = ({ signal }) => getEmployeeGroup(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeGroup>>>
export type GetEmployeeGroupQueryError = ErrorType<ErrorDetails>


export function useGetEmployeeGroup<TData = Awaited<ReturnType<typeof getEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeGroup>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeGroup<TData = Awaited<ReturnType<typeof getEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeGroup>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeGroup<TData = Awaited<ReturnType<typeof getEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeGroup>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get single employee group with members
 */

export function useGetEmployeeGroup<TData = Awaited<ReturnType<typeof getEmployeeGroup>>, TError = ErrorType<ErrorDetails>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeGroup>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeGroupQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update employee group
 */
export const updateEmployeeGroup = (
    id: number,
    employeeGroupJSON: BodyType<EmployeeGroupJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/employee-groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: employeeGroupJSON, signal
    },
      options);
    }



export const getUpdateEmployeeGroupMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeGroup>>, TError,{id: number;data: BodyType<EmployeeGroupJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeGroup>>, TError,{id: number;data: BodyType<EmployeeGroupJSON>}, TContext> => {

const mutationKey = ['updateEmployeeGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployeeGroup>>, {id: number;data: BodyType<EmployeeGroupJSON>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployeeGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployeeGroup>>>
    export type UpdateEmployeeGroupMutationBody = BodyType<EmployeeGroupJSON>
    export type UpdateEmployeeGroupMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Update employee group
 */
export const useUpdateEmployeeGroup = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployeeGroup>>, TError,{id: number;data: BodyType<EmployeeGroupJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployeeGroup>>,
        TError,
        {id: number;data: BodyType<EmployeeGroupJSON>},
        TContext
      > => {
      return useMutation(getUpdateEmployeeGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Soft-delete employee group if empty
 */
export const deleteEmployeeGroup = (
    id: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/employee-groups/${id}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteEmployeeGroupMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeGroup>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEmployeeGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeGroup>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployeeGroup(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeGroup>>>

    export type DeleteEmployeeGroupMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Soft-delete employee group if empty
 */
export const useDeleteEmployeeGroup = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployeeGroup>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteEmployeeGroupMutationOptions(options), queryClient);
    }
    /**
 * Retrieves vacation balances for all employees. Can be filtered by vacation year.
 * @summary Get all not deleted vacation balances for the company
 */
export const getCompanyBalances = (
    params?: GetCompanyBalancesParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonVacationBalanceJSON[]>(
      {url: `/api/v1/rest/vacation-balances`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCompanyBalancesQueryKey = (params?: GetCompanyBalancesParams,) => {
    return [
    `/api/v1/rest/vacation-balances`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompanyBalancesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyBalances>>, TError = ErrorType<ErrorDetails>>(params?: GetCompanyBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyBalancesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyBalances>>> = ({ signal }) => getCompanyBalances(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyBalances>>>
export type GetCompanyBalancesQueryError = ErrorType<ErrorDetails>


export function useGetCompanyBalances<TData = Awaited<ReturnType<typeof getCompanyBalances>>, TError = ErrorType<ErrorDetails>>(
 params: undefined |  GetCompanyBalancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyBalances>>,
          TError,
          Awaited<ReturnType<typeof getCompanyBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyBalances<TData = Awaited<ReturnType<typeof getCompanyBalances>>, TError = ErrorType<ErrorDetails>>(
 params?: GetCompanyBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyBalances>>,
          TError,
          Awaited<ReturnType<typeof getCompanyBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyBalances<TData = Awaited<ReturnType<typeof getCompanyBalances>>, TError = ErrorType<ErrorDetails>>(
 params?: GetCompanyBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all not deleted vacation balances for the company
 */

export function useGetCompanyBalances<TData = Awaited<ReturnType<typeof getCompanyBalances>>, TError = ErrorType<ErrorDetails>>(
 params?: GetCompanyBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyBalancesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new manual vacation balance entry
 * @summary Create a new vacation balance
 */
export const createBalance = (
    modifyPersonVacationBalanceJSON: BodyType<ModifyPersonVacationBalanceJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonVacationBalanceJSON>(
      {url: `/api/v1/rest/vacation-balances`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modifyPersonVacationBalanceJSON, signal
    },
      options);
    }



export const getCreateBalanceMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBalance>>, TError,{data: BodyType<ModifyPersonVacationBalanceJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBalance>>, TError,{data: BodyType<ModifyPersonVacationBalanceJSON>}, TContext> => {

const mutationKey = ['createBalance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBalance>>, {data: BodyType<ModifyPersonVacationBalanceJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createBalance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof createBalance>>>
    export type CreateBalanceMutationBody = BodyType<ModifyPersonVacationBalanceJSON>
    export type CreateBalanceMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Create a new vacation balance
 */
export const useCreateBalance = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBalance>>, TError,{data: BodyType<ModifyPersonVacationBalanceJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBalance>>,
        TError,
        {data: BodyType<ModifyPersonVacationBalanceJSON>},
        TContext
      > => {
      return useMutation(getCreateBalanceMutationOptions(options), queryClient);
    }
    /**
 * Fetches all teams from the personal data microservice
 * @summary Get all teams
 */
export const getAllTeams = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/teams`, method: 'GET', signal
    },
      options);
    }




export const getGetAllTeamsQueryKey = () => {
    return [
    `/api/v1/rest/teams`
    ] as const;
    }


export const getGetAllTeamsQueryOptions = <TData = Awaited<ReturnType<typeof getAllTeams>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTeams>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTeamsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTeams>>> = ({ signal }) => getAllTeams(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTeams>>>
export type GetAllTeamsQueryError = ErrorType<ErrorDetails>


export function useGetAllTeams<TData = Awaited<ReturnType<typeof getAllTeams>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTeams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTeams>>,
          TError,
          Awaited<ReturnType<typeof getAllTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTeams<TData = Awaited<ReturnType<typeof getAllTeams>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTeams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTeams>>,
          TError,
          Awaited<ReturnType<typeof getAllTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTeams<TData = Awaited<ReturnType<typeof getAllTeams>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTeams>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all teams
 */

export function useGetAllTeams<TData = Awaited<ReturnType<typeof getAllTeams>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTeams>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllTeamsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a new team
 */
export const createTeam = (
    teamJSON: BodyType<TeamJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamJSON, signal
    },
      options);
    }



export const getCreateTeamMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: BodyType<TeamJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: BodyType<TeamJSON>}, TContext> => {

const mutationKey = ['createTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeam>>, {data: BodyType<TeamJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createTeam(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createTeam>>>
    export type CreateTeamMutationBody = BodyType<TeamJSON>
    export type CreateTeamMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Create a new team
 */
export const useCreateTeam = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: BodyType<TeamJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTeam>>,
        TError,
        {data: BodyType<TeamJSON>},
        TContext
      > => {
      return useMutation(getCreateTeamMutationOptions(options), queryClient);
    }
    /**
 * Retrieves all configured and active supplement mappings for the authenticated company.
 * @summary Get all salary type supplement mappings for a company
 */
export const getSalaryTypeSupplementMappings = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<SalaryTypeSupplementMappingJSON[]>(
      {url: `/api/v1/rest/salary-mapping/supplements`, method: 'GET', signal
    },
      options);
    }




export const getGetSalaryTypeSupplementMappingsQueryKey = () => {
    return [
    `/api/v1/rest/salary-mapping/supplements`
    ] as const;
    }


export const getGetSalaryTypeSupplementMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalaryTypeSupplementMappingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>> = ({ signal }) => getSalaryTypeSupplementMappings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSalaryTypeSupplementMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>>
export type GetSalaryTypeSupplementMappingsQueryError = ErrorType<unknown>


export function useGetSalaryTypeSupplementMappings<TData = Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>,
          TError,
          Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalaryTypeSupplementMappings<TData = Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>,
          TError,
          Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalaryTypeSupplementMappings<TData = Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all salary type supplement mappings for a company
 */

export function useGetSalaryTypeSupplementMappings<TData = Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalaryTypeSupplementMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSalaryTypeSupplementMappingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new mapping between a HR supplement code (SUPPLEMENT1-16) and a Procountor salary type code.
 * @summary Create a new salary type supplement mapping
 */
export const createSalaryTypeSupplementMapping = (
    modifySalaryTypeSupplementMappingJSON: BodyType<ModifySalaryTypeSupplementMappingJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<SalaryTypeSupplementMappingJSON>(
      {url: `/api/v1/rest/salary-mapping/supplements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modifySalaryTypeSupplementMappingJSON, signal
    },
      options);
    }



export const getCreateSalaryTypeSupplementMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalaryTypeSupplementMapping>>, TError,{data: BodyType<ModifySalaryTypeSupplementMappingJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSalaryTypeSupplementMapping>>, TError,{data: BodyType<ModifySalaryTypeSupplementMappingJSON>}, TContext> => {

const mutationKey = ['createSalaryTypeSupplementMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalaryTypeSupplementMapping>>, {data: BodyType<ModifySalaryTypeSupplementMappingJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createSalaryTypeSupplementMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalaryTypeSupplementMappingMutationResult = NonNullable<Awaited<ReturnType<typeof createSalaryTypeSupplementMapping>>>
    export type CreateSalaryTypeSupplementMappingMutationBody = BodyType<ModifySalaryTypeSupplementMappingJSON>
    export type CreateSalaryTypeSupplementMappingMutationError = ErrorType<unknown>

    /**
 * @summary Create a new salary type supplement mapping
 */
export const useCreateSalaryTypeSupplementMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalaryTypeSupplementMapping>>, TError,{data: BodyType<ModifySalaryTypeSupplementMappingJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSalaryTypeSupplementMapping>>,
        TError,
        {data: BodyType<ModifySalaryTypeSupplementMappingJSON>},
        TContext
      > => {
      return useMutation(getCreateSalaryTypeSupplementMappingMutationOptions(options), queryClient);
    }
    /**
 * Initializes default mappings between HR supplement codes (SUPPLEMENT1-16) and Procountor salary type codes for the authenticated company.
 * @summary Initialize default salary type supplement mappings
 */
export const initializeSalaryTypeSupplementMappings = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/salary-mapping/supplements/initialize`, method: 'POST', signal
    },
      options);
    }



export const getInitializeSalaryTypeSupplementMappingsMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeSalaryTypeSupplementMappings>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeSalaryTypeSupplementMappings>>, TError,void, TContext> => {

const mutationKey = ['initializeSalaryTypeSupplementMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeSalaryTypeSupplementMappings>>, void> = () => {


          return  initializeSalaryTypeSupplementMappings(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitializeSalaryTypeSupplementMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof initializeSalaryTypeSupplementMappings>>>

    export type InitializeSalaryTypeSupplementMappingsMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Initialize default salary type supplement mappings
 */
export const useInitializeSalaryTypeSupplementMappings = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeSalaryTypeSupplementMappings>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initializeSalaryTypeSupplementMappings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getInitializeSalaryTypeSupplementMappingsMutationOptions(options), queryClient);
    }
    /**
 * Search persons from database. Results are paginated and sorted.
 * @summary Search persons
 */
export const searchPersons = (
    personSearchResponseJSON: BodyType<PersonSearchResponseJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonSearchResponseJSON>(
      {url: `/api/v1/rest/persons/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: personSearchResponseJSON, signal
    },
      options);
    }



export const getSearchPersonsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchPersons>>, TError,{data: BodyType<PersonSearchResponseJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchPersons>>, TError,{data: BodyType<PersonSearchResponseJSON>}, TContext> => {

const mutationKey = ['searchPersons'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchPersons>>, {data: BodyType<PersonSearchResponseJSON>}> = (props) => {
          const {data} = props ?? {};

          return  searchPersons(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchPersonsMutationResult = NonNullable<Awaited<ReturnType<typeof searchPersons>>>
    export type SearchPersonsMutationBody = BodyType<PersonSearchResponseJSON>
    export type SearchPersonsMutationError = ErrorType<unknown>

    /**
 * @summary Search persons
 */
export const useSearchPersons = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchPersons>>, TError,{data: BodyType<PersonSearchResponseJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchPersons>>,
        TError,
        {data: BodyType<PersonSearchResponseJSON>},
        TContext
      > => {
      return useMutation(getSearchPersonsMutationOptions(options), queryClient);
    }
    /**
 * Creates a new person or modifies existing person
 * @summary Create/Modify person
 */
export const createPerson = (
    personJSON: BodyType<PersonJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON>(
      {url: `/api/v1/rest/person`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: personJSON, signal
    },
      options);
    }



export const getCreatePersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: BodyType<PersonJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: BodyType<PersonJSON>}, TContext> => {

const mutationKey = ['createPerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerson>>, {data: BodyType<PersonJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createPerson(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof createPerson>>>
    export type CreatePersonMutationBody = BodyType<PersonJSON>
    export type CreatePersonMutationError = ErrorType<unknown>

    /**
 * @summary Create/Modify person
 */
export const useCreatePerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: BodyType<PersonJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPerson>>,
        TError,
        {data: BodyType<PersonJSON>},
        TContext
      > => {
      return useMutation(getCreatePersonMutationOptions(options), queryClient);
    }
    /**
 * Modify person data with provided person number
 * @summary Modify person data
 */
export const modifyPerson = (
    nr: number,
    personJSON: BodyType<PersonJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON>(
      {url: `/api/v1/rest/person/number/${nr}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: personJSON, signal
    },
      options);
    }



export const getModifyPersonMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modifyPerson>>, TError,{nr: number;data: BodyType<PersonJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof modifyPerson>>, TError,{nr: number;data: BodyType<PersonJSON>}, TContext> => {

const mutationKey = ['modifyPerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modifyPerson>>, {nr: number;data: BodyType<PersonJSON>}> = (props) => {
          const {nr,data} = props ?? {};

          return  modifyPerson(nr,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModifyPersonMutationResult = NonNullable<Awaited<ReturnType<typeof modifyPerson>>>
    export type ModifyPersonMutationBody = BodyType<PersonJSON>
    export type ModifyPersonMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Modify person data
 */
export const useModifyPerson = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modifyPerson>>, TError,{nr: number;data: BodyType<PersonJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modifyPerson>>,
        TError,
        {nr: number;data: BodyType<PersonJSON>},
        TContext
      > => {
      return useMutation(getModifyPersonMutationOptions(options), queryClient);
    }
    /**
 * Updates attachment count in to the database
 * @summary Update person attachment count
 */
export const updatePersonAttachmentCount = (
    personJSON: BodyType<PersonJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON>(
      {url: `/api/v1/rest/person/attachmentcount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: personJSON, signal
    },
      options);
    }



export const getUpdatePersonAttachmentCountMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonAttachmentCount>>, TError,{data: BodyType<PersonJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePersonAttachmentCount>>, TError,{data: BodyType<PersonJSON>}, TContext> => {

const mutationKey = ['updatePersonAttachmentCount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePersonAttachmentCount>>, {data: BodyType<PersonJSON>}> = (props) => {
          const {data} = props ?? {};

          return  updatePersonAttachmentCount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePersonAttachmentCountMutationResult = NonNullable<Awaited<ReturnType<typeof updatePersonAttachmentCount>>>
    export type UpdatePersonAttachmentCountMutationBody = BodyType<PersonJSON>
    export type UpdatePersonAttachmentCountMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Update person attachment count
 */
export const useUpdatePersonAttachmentCount = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonAttachmentCount>>, TError,{data: BodyType<PersonJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePersonAttachmentCount>>,
        TError,
        {data: BodyType<PersonJSON>},
        TContext
      > => {
      return useMutation(getUpdatePersonAttachmentCountMutationOptions(options), queryClient);
    }
    /**
 * Import employees from PSA and export to eSalary
 * @summary Import employees from PSA to HR
 */
export const importPsa = (
    params?: ImportPsaParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/import-psa`, method: 'POST',
        params, signal
    },
      options);
    }



export const getImportPsaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importPsa>>, TError,{params?: ImportPsaParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importPsa>>, TError,{params?: ImportPsaParams}, TContext> => {

const mutationKey = ['importPsa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importPsa>>, {params?: ImportPsaParams}> = (props) => {
          const {params} = props ?? {};

          return  importPsa(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportPsaMutationResult = NonNullable<Awaited<ReturnType<typeof importPsa>>>

    export type ImportPsaMutationError = ErrorType<unknown>

    /**
 * @summary Import employees from PSA to HR
 */
export const useImportPsa = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importPsa>>, TError,{params?: ImportPsaParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importPsa>>,
        TError,
        {params?: ImportPsaParams},
        TContext
      > => {
      return useMutation(getImportPsaMutationOptions(options), queryClient);
    }
    /**
 * Import persons from Procountor and export to eSalary
 * @summary Import persons from Procountor to HR
 */
export const importProcountor = (
    importProcountorBody: BodyType<number[]>,
    params?: ImportProcountorParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/import-procountor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importProcountorBody,
        params, signal
    },
      options);
    }



export const getImportProcountorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProcountor>>, TError,{data: BodyType<number[]>;params?: ImportProcountorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importProcountor>>, TError,{data: BodyType<number[]>;params?: ImportProcountorParams}, TContext> => {

const mutationKey = ['importProcountor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importProcountor>>, {data: BodyType<number[]>;params?: ImportProcountorParams}> = (props) => {
          const {data,params} = props ?? {};

          return  importProcountor(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportProcountorMutationResult = NonNullable<Awaited<ReturnType<typeof importProcountor>>>
    export type ImportProcountorMutationBody = BodyType<number[]>
    export type ImportProcountorMutationError = ErrorType<unknown>

    /**
 * @summary Import persons from Procountor to HR
 */
export const useImportProcountor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProcountor>>, TError,{data: BodyType<number[]>;params?: ImportProcountorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importProcountor>>,
        TError,
        {data: BodyType<number[]>;params?: ImportProcountorParams},
        TContext
      > => {
      return useMutation(getImportProcountorMutationOptions(options), queryClient);
    }
    /**
 * Import persons from Netvisor and export to eSalary
 * @summary Import persons from Netvisor to HR
 */
export const importNetvisor = (
    importNetvisorBody: BodyType<number[]>,
    params?: ImportNetvisorParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/import-netvisor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importNetvisorBody,
        params, signal
    },
      options);
    }



export const getImportNetvisorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importNetvisor>>, TError,{data: BodyType<number[]>;params?: ImportNetvisorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importNetvisor>>, TError,{data: BodyType<number[]>;params?: ImportNetvisorParams}, TContext> => {

const mutationKey = ['importNetvisor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importNetvisor>>, {data: BodyType<number[]>;params?: ImportNetvisorParams}> = (props) => {
          const {data,params} = props ?? {};

          return  importNetvisor(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportNetvisorMutationResult = NonNullable<Awaited<ReturnType<typeof importNetvisor>>>
    export type ImportNetvisorMutationBody = BodyType<number[]>
    export type ImportNetvisorMutationError = ErrorType<unknown>

    /**
 * @summary Import persons from Netvisor to HR
 */
export const useImportNetvisor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importNetvisor>>, TError,{data: BodyType<number[]>;params?: ImportNetvisorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importNetvisor>>,
        TError,
        {data: BodyType<number[]>;params?: ImportNetvisorParams},
        TContext
      > => {
      return useMutation(getImportNetvisorMutationOptions(options), queryClient);
    }
    /**
 * Import employees from eSalary
 * @summary Import employees
 */
export const createPerson1 = (
    importEmployeesRequestJSON: BodyType<ImportEmployeesRequestJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/import-employees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importEmployeesRequestJSON, signal
    },
      options);
    }



export const getCreatePerson1MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson1>>, TError,{data: BodyType<ImportEmployeesRequestJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerson1>>, TError,{data: BodyType<ImportEmployeesRequestJSON>}, TContext> => {

const mutationKey = ['createPerson1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerson1>>, {data: BodyType<ImportEmployeesRequestJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createPerson1(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePerson1MutationResult = NonNullable<Awaited<ReturnType<typeof createPerson1>>>
    export type CreatePerson1MutationBody = BodyType<ImportEmployeesRequestJSON>
    export type CreatePerson1MutationError = ErrorType<unknown>

    /**
 * @summary Import employees
 */
export const useCreatePerson1 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson1>>, TError,{data: BodyType<ImportEmployeesRequestJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPerson1>>,
        TError,
        {data: BodyType<ImportEmployeesRequestJSON>},
        TContext
      > => {
      return useMutation(getCreatePerson1MutationOptions(options), queryClient);
    }
    /**
 * Export HR persons to Visma Severa users
 * @summary Export persons from HR to Severa users
 */
export const exportSevera = (
    exportSeveraBody: BodyType<number[]>,
    params?: ExportSeveraParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/export-severa`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportSeveraBody,
        params, signal
    },
      options);
    }



export const getExportSeveraMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportSevera>>, TError,{data: BodyType<number[]>;params?: ExportSeveraParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exportSevera>>, TError,{data: BodyType<number[]>;params?: ExportSeveraParams}, TContext> => {

const mutationKey = ['exportSevera'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportSevera>>, {data: BodyType<number[]>;params?: ExportSeveraParams}> = (props) => {
          const {data,params} = props ?? {};

          return  exportSevera(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportSeveraMutationResult = NonNullable<Awaited<ReturnType<typeof exportSevera>>>
    export type ExportSeveraMutationBody = BodyType<number[]>
    export type ExportSeveraMutationError = ErrorType<unknown>

    /**
 * @summary Export persons from HR to Severa users
 */
export const useExportSevera = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportSevera>>, TError,{data: BodyType<number[]>;params?: ExportSeveraParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exportSevera>>,
        TError,
        {data: BodyType<number[]>;params?: ExportSeveraParams},
        TContext
      > => {
      return useMutation(getExportSeveraMutationOptions(options), queryClient);
    }
    /**
 * Export HR persons to PSA employees
 * @summary Export persons from HR to PSA
 */
export const exportPsa = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/export-psa`, method: 'POST', signal
    },
      options);
    }



export const getExportPsaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportPsa>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exportPsa>>, TError,void, TContext> => {

const mutationKey = ['exportPsa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportPsa>>, void> = () => {


          return  exportPsa(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportPsaMutationResult = NonNullable<Awaited<ReturnType<typeof exportPsa>>>

    export type ExportPsaMutationError = ErrorType<unknown>

    /**
 * @summary Export persons from HR to PSA
 */
export const useExportPsa = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportPsa>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exportPsa>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getExportPsaMutationOptions(options), queryClient);
    }
    /**
 * Export HR persons to Procountor persons
 * @summary Export HR persons to Procountor
 */
export const exportProcountor = (
    exportProcountorBody: BodyType<number[]>,
    params?: ExportProcountorParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/export-procountor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportProcountorBody,
        params, signal
    },
      options);
    }



export const getExportProcountorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportProcountor>>, TError,{data: BodyType<number[]>;params?: ExportProcountorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exportProcountor>>, TError,{data: BodyType<number[]>;params?: ExportProcountorParams}, TContext> => {

const mutationKey = ['exportProcountor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportProcountor>>, {data: BodyType<number[]>;params?: ExportProcountorParams}> = (props) => {
          const {data,params} = props ?? {};

          return  exportProcountor(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportProcountorMutationResult = NonNullable<Awaited<ReturnType<typeof exportProcountor>>>
    export type ExportProcountorMutationBody = BodyType<number[]>
    export type ExportProcountorMutationError = ErrorType<unknown>

    /**
 * @summary Export HR persons to Procountor
 */
export const useExportProcountor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportProcountor>>, TError,{data: BodyType<number[]>;params?: ExportProcountorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exportProcountor>>,
        TError,
        {data: BodyType<number[]>;params?: ExportProcountorParams},
        TContext
      > => {
      return useMutation(getExportProcountorMutationOptions(options), queryClient);
    }
    /**
 * Export HR persons to Netvisor persons
 * @summary Export HR persons to Netvisor
 */
export const exportNetvisor = (
    exportNetvisorBody: BodyType<number[]>,
    params?: ExportNetvisorParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ImportEmployeesResponseJSON>(
      {url: `/api/v1/rest/export-netvisor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportNetvisorBody,
        params, signal
    },
      options);
    }



export const getExportNetvisorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportNetvisor>>, TError,{data: BodyType<number[]>;params?: ExportNetvisorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exportNetvisor>>, TError,{data: BodyType<number[]>;params?: ExportNetvisorParams}, TContext> => {

const mutationKey = ['exportNetvisor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportNetvisor>>, {data: BodyType<number[]>;params?: ExportNetvisorParams}> = (props) => {
          const {data,params} = props ?? {};

          return  exportNetvisor(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportNetvisorMutationResult = NonNullable<Awaited<ReturnType<typeof exportNetvisor>>>
    export type ExportNetvisorMutationBody = BodyType<number[]>
    export type ExportNetvisorMutationError = ErrorType<unknown>

    /**
 * @summary Export HR persons to Netvisor
 */
export const useExportNetvisor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportNetvisor>>, TError,{data: BodyType<number[]>;params?: ExportNetvisorParams}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exportNetvisor>>,
        TError,
        {data: BodyType<number[]>;params?: ExportNetvisorParams},
        TContext
      > => {
      return useMutation(getExportNetvisorMutationOptions(options), queryClient);
    }
    /**
 * Creates a new or modifies existing employment certificate
 * @summary Create/Modify certificate
 */
export const createCertificate = (
    employmentCertificateJSON: BodyType<EmploymentCertificateJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<EmploymentCertificateJSON>(
      {url: `/api/v1/rest/employment-certificate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employmentCertificateJSON, signal
    },
      options);
    }



export const getCreateCertificateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{data: BodyType<EmploymentCertificateJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{data: BodyType<EmploymentCertificateJSON>}, TContext> => {

const mutationKey = ['createCertificate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCertificate>>, {data: BodyType<EmploymentCertificateJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createCertificate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof createCertificate>>>
    export type CreateCertificateMutationBody = BodyType<EmploymentCertificateJSON>
    export type CreateCertificateMutationError = ErrorType<unknown>

    /**
 * @summary Create/Modify certificate
 */
export const useCreateCertificate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{data: BodyType<EmploymentCertificateJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCertificate>>,
        TError,
        {data: BodyType<EmploymentCertificateJSON>},
        TContext
      > => {
      return useMutation(getCreateCertificateMutationOptions(options), queryClient);
    }
    /**
 * @summary Get all employee groups for a company
 */
export const getAllEmployeeGroups = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/employee-groups`, method: 'GET', signal
    },
      options);
    }




export const getGetAllEmployeeGroupsQueryKey = () => {
    return [
    `/api/v1/rest/employee-groups`
    ] as const;
    }


export const getGetAllEmployeeGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllEmployeeGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllEmployeeGroups>>> = ({ signal }) => getAllEmployeeGroups(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllEmployeeGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllEmployeeGroups>>>
export type GetAllEmployeeGroupsQueryError = ErrorType<ErrorDetails>


export function useGetAllEmployeeGroups<TData = Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllEmployeeGroups>>,
          TError,
          Awaited<ReturnType<typeof getAllEmployeeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllEmployeeGroups<TData = Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllEmployeeGroups>>,
          TError,
          Awaited<ReturnType<typeof getAllEmployeeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllEmployeeGroups<TData = Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all employee groups for a company
 */

export function useGetAllEmployeeGroups<TData = Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEmployeeGroups>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllEmployeeGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a new employee group
 */
export const createEmployeeGroup = (
    employeeGroupJSON: BodyType<EmployeeGroupJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/employee-groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employeeGroupJSON, signal
    },
      options);
    }



export const getCreateEmployeeGroupMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeGroup>>, TError,{data: BodyType<EmployeeGroupJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployeeGroup>>, TError,{data: BodyType<EmployeeGroupJSON>}, TContext> => {

const mutationKey = ['createEmployeeGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployeeGroup>>, {data: BodyType<EmployeeGroupJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createEmployeeGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployeeGroup>>>
    export type CreateEmployeeGroupMutationBody = BodyType<EmployeeGroupJSON>
    export type CreateEmployeeGroupMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Create a new employee group
 */
export const useCreateEmployeeGroup = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeGroup>>, TError,{data: BodyType<EmployeeGroupJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmployeeGroup>>,
        TError,
        {data: BodyType<EmployeeGroupJSON>},
        TContext
      > => {
      return useMutation(getCreateEmployeeGroupMutationOptions(options), queryClient);
    }
    /**
 * Set status to CANCELED for the current salary row
 * @summary Cancel salary history row
 */
export const cancelPersonSalaryHistory = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonDetailsSalaryJSON>(
      {url: `/api/v1/rest/persons/salary-history/${personId}/cancel`, method: 'PATCH', signal
    },
      options);
    }



export const getCancelPersonSalaryHistoryMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPersonSalaryHistory>>, TError,{personId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPersonSalaryHistory>>, TError,{personId: number}, TContext> => {

const mutationKey = ['cancelPersonSalaryHistory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPersonSalaryHistory>>, {personId: number}> = (props) => {
          const {personId} = props ?? {};

          return  cancelPersonSalaryHistory(personId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPersonSalaryHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPersonSalaryHistory>>>

    export type CancelPersonSalaryHistoryMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Cancel salary history row
 */
export const useCancelPersonSalaryHistory = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPersonSalaryHistory>>, TError,{personId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelPersonSalaryHistory>>,
        TError,
        {personId: number},
        TContext
      > => {
      return useMutation(getCancelPersonSalaryHistoryMutationOptions(options), queryClient);
    }
    /**
 * Retrieves vacation balances for a person. Filtered by selected vacation year in settings.
 * @summary Get all vacation balances for the person
 */
export const getPersonBalances = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonVacationBalanceJSON>(
      {url: `/api/v1/rest/vacation-balances/person/${personId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonBalancesQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/vacation-balances/person/${personId}`
    ] as const;
    }


export const getGetPersonBalancesQueryOptions = <TData = Awaited<ReturnType<typeof getPersonBalances>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonBalancesQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonBalances>>> = ({ signal }) => getPersonBalances(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonBalances>>>
export type GetPersonBalancesQueryError = ErrorType<ErrorDetails>


export function useGetPersonBalances<TData = Awaited<ReturnType<typeof getPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonBalances>>,
          TError,
          Awaited<ReturnType<typeof getPersonBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonBalances<TData = Awaited<ReturnType<typeof getPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonBalances>>,
          TError,
          Awaited<ReturnType<typeof getPersonBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonBalances<TData = Awaited<ReturnType<typeof getPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all vacation balances for the person
 */

export function useGetPersonBalances<TData = Awaited<ReturnType<typeof getPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonBalancesQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves yearly vacation balances for a person. Filtered by selected vacation year in settings.
 * @summary Get yearly vacation balances for the person
 */
export const getYearlyPersonBalances = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonVacationBalanceJSON[]>(
      {url: `/api/v1/rest/vacation-balances-yearly/person/${personId}`, method: 'GET', signal
    },
      options);
    }




export const getGetYearlyPersonBalancesQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/vacation-balances-yearly/person/${personId}`
    ] as const;
    }


export const getGetYearlyPersonBalancesQueryOptions = <TData = Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetYearlyPersonBalancesQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getYearlyPersonBalances>>> = ({ signal }) => getYearlyPersonBalances(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetYearlyPersonBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getYearlyPersonBalances>>>
export type GetYearlyPersonBalancesQueryError = ErrorType<ErrorDetails>


export function useGetYearlyPersonBalances<TData = Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getYearlyPersonBalances>>,
          TError,
          Awaited<ReturnType<typeof getYearlyPersonBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetYearlyPersonBalances<TData = Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getYearlyPersonBalances>>,
          TError,
          Awaited<ReturnType<typeof getYearlyPersonBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetYearlyPersonBalances<TData = Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get yearly vacation balances for the person
 */

export function useGetYearlyPersonBalances<TData = Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYearlyPersonBalances>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetYearlyPersonBalancesQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves all configured supplement mapping names for the company.
 * @summary Get all salary type supplement mappings names for a company
 */
export const getSupplementMappingNames = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<SalaryTypeSupplementMappingLabelJSON[]>(
      {url: `/api/v1/rest/salary-mapping/supplements/names`, method: 'GET', signal
    },
      options);
    }




export const getGetSupplementMappingNamesQueryKey = () => {
    return [
    `/api/v1/rest/salary-mapping/supplements/names`
    ] as const;
    }


export const getGetSupplementMappingNamesQueryOptions = <TData = Awaited<ReturnType<typeof getSupplementMappingNames>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplementMappingNames>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplementMappingNamesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplementMappingNames>>> = ({ signal }) => getSupplementMappingNames(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplementMappingNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupplementMappingNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplementMappingNames>>>
export type GetSupplementMappingNamesQueryError = ErrorType<ErrorDetails>


export function useGetSupplementMappingNames<TData = Awaited<ReturnType<typeof getSupplementMappingNames>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplementMappingNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplementMappingNames>>,
          TError,
          Awaited<ReturnType<typeof getSupplementMappingNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplementMappingNames<TData = Awaited<ReturnType<typeof getSupplementMappingNames>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplementMappingNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplementMappingNames>>,
          TError,
          Awaited<ReturnType<typeof getSupplementMappingNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplementMappingNames<TData = Awaited<ReturnType<typeof getSupplementMappingNames>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplementMappingNames>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all salary type supplement mappings names for a company
 */

export function useGetSupplementMappingNames<TData = Awaited<ReturnType<typeof getSupplementMappingNames>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplementMappingNames>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupplementMappingNamesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns all persons assigned teams
 * @summary Get summary of person teams
 */
export const getPersonTeams = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonTeamSummaryJSON>(
      {url: `/api/v1/rest/persons/${personId}/teams-summary`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonTeamsQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/persons/${personId}/teams-summary`
    ] as const;
    }


export const getGetPersonTeamsQueryOptions = <TData = Awaited<ReturnType<typeof getPersonTeams>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeams>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonTeamsQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonTeams>>> = ({ signal }) => getPersonTeams(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonTeams>>>
export type GetPersonTeamsQueryError = ErrorType<ErrorDetails>


export function useGetPersonTeams<TData = Awaited<ReturnType<typeof getPersonTeams>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonTeams>>,
          TError,
          Awaited<ReturnType<typeof getPersonTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonTeams<TData = Awaited<ReturnType<typeof getPersonTeams>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonTeams>>,
          TError,
          Awaited<ReturnType<typeof getPersonTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonTeams<TData = Awaited<ReturnType<typeof getPersonTeams>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeams>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get summary of person teams
 */

export function useGetPersonTeams<TData = Awaited<ReturnType<typeof getPersonTeams>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeams>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonTeamsQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns a list of all persons with their assigned teams for table view
 * @summary Get summary of persons and their teams
 */
export const getPersonTeamSummary = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonTeamSummaryJSON[]>(
      {url: `/api/v1/rest/persons/teams-summary`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonTeamSummaryQueryKey = () => {
    return [
    `/api/v1/rest/persons/teams-summary`
    ] as const;
    }


export const getGetPersonTeamSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPersonTeamSummary>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeamSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonTeamSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonTeamSummary>>> = ({ signal }) => getPersonTeamSummary(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonTeamSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonTeamSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonTeamSummary>>>
export type GetPersonTeamSummaryQueryError = ErrorType<ErrorDetails>


export function useGetPersonTeamSummary<TData = Awaited<ReturnType<typeof getPersonTeamSummary>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeamSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonTeamSummary>>,
          TError,
          Awaited<ReturnType<typeof getPersonTeamSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonTeamSummary<TData = Awaited<ReturnType<typeof getPersonTeamSummary>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeamSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonTeamSummary>>,
          TError,
          Awaited<ReturnType<typeof getPersonTeamSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonTeamSummary<TData = Awaited<ReturnType<typeof getPersonTeamSummary>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeamSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get summary of persons and their teams
 */

export function useGetPersonTeamSummary<TData = Awaited<ReturnType<typeof getPersonTeamSummary>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonTeamSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonTeamSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetches the supervisors of active persons
 * @summary List all supervisor persons
 */
export const getSupervisors1 = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonSummaryJSON[]>(
      {url: `/api/v1/rest/persons/supervisors`, method: 'GET', signal
    },
      options);
    }




export const getGetSupervisors1QueryKey = () => {
    return [
    `/api/v1/rest/persons/supervisors`
    ] as const;
    }


export const getGetSupervisors1QueryOptions = <TData = Awaited<ReturnType<typeof getSupervisors1>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisors1>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisors1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisors1>>> = ({ signal }) => getSupervisors1(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisors1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupervisors1QueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisors1>>>
export type GetSupervisors1QueryError = ErrorType<ErrorDetails>


export function useGetSupervisors1<TData = Awaited<ReturnType<typeof getSupervisors1>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisors1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupervisors1>>,
          TError,
          Awaited<ReturnType<typeof getSupervisors1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupervisors1<TData = Awaited<ReturnType<typeof getSupervisors1>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisors1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupervisors1>>,
          TError,
          Awaited<ReturnType<typeof getSupervisors1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupervisors1<TData = Awaited<ReturnType<typeof getSupervisors1>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisors1>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all supervisor persons
 */

export function useGetSupervisors1<TData = Awaited<ReturnType<typeof getSupervisors1>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisors1>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupervisors1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of persons summary from database
 * @summary Get a summary of all persons
 */
export const getPersonsSummary = (
    list: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonSummaryJSON[]>(
      {url: `/api/v1/rest/persons/summary/${list}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonsSummaryQueryKey = (list: string,) => {
    return [
    `/api/v1/rest/persons/summary/${list}`
    ] as const;
    }


export const getGetPersonsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPersonsSummary>>, TError = ErrorType<ErrorDetails>>(list: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonsSummaryQueryKey(list);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonsSummary>>> = ({ signal }) => getPersonsSummary(list, requestOptions, signal);





   return  { queryKey, queryFn, enabled: list !== null && list !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonsSummary>>>
export type GetPersonsSummaryQueryError = ErrorType<ErrorDetails>


export function useGetPersonsSummary<TData = Awaited<ReturnType<typeof getPersonsSummary>>, TError = ErrorType<ErrorDetails>>(
 list: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsSummary>>,
          TError,
          Awaited<ReturnType<typeof getPersonsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsSummary<TData = Awaited<ReturnType<typeof getPersonsSummary>>, TError = ErrorType<ErrorDetails>>(
 list: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsSummary>>,
          TError,
          Awaited<ReturnType<typeof getPersonsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsSummary<TData = Awaited<ReturnType<typeof getPersonsSummary>>, TError = ErrorType<ErrorDetails>>(
 list: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a summary of all persons
 */

export function useGetPersonsSummary<TData = Awaited<ReturnType<typeof getPersonsSummary>>, TError = ErrorType<ErrorDetails>>(
 list: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonsSummaryQueryOptions(list,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Salary history (audit) for person from personal-data microservice
 * @summary Get salary history for a person
 */
export const getPersonSalaryHistory = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonDetailsSalary[]>(
      {url: `/api/v1/rest/persons/salary-history/${personId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonSalaryHistoryQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/persons/salary-history/${personId}`
    ] as const;
    }


export const getGetPersonSalaryHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonSalaryHistoryQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonSalaryHistory>>> = ({ signal }) => getPersonSalaryHistory(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonSalaryHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonSalaryHistory>>>
export type GetPersonSalaryHistoryQueryError = ErrorType<ErrorDetails>


export function useGetPersonSalaryHistory<TData = Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonSalaryHistory>>,
          TError,
          Awaited<ReturnType<typeof getPersonSalaryHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonSalaryHistory<TData = Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonSalaryHistory>>,
          TError,
          Awaited<ReturnType<typeof getPersonSalaryHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonSalaryHistory<TData = Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get salary history for a person
 */

export function useGetPersonSalaryHistory<TData = Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonSalaryHistory>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonSalaryHistoryQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Salary history (audit) for all persons from personal-data microservice
 * @summary Get salary history for all persons
 */
export const getAllSalaryHistories = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonDetailsSalaryJSON[]>(
      {url: `/api/v1/rest/persons/salary-history/all`, method: 'GET', signal
    },
      options);
    }




export const getGetAllSalaryHistoriesQueryKey = () => {
    return [
    `/api/v1/rest/persons/salary-history/all`
    ] as const;
    }


export const getGetAllSalaryHistoriesQueryOptions = <TData = Awaited<ReturnType<typeof getAllSalaryHistories>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSalaryHistories>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllSalaryHistoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSalaryHistories>>> = ({ signal }) => getAllSalaryHistories(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllSalaryHistories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllSalaryHistoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllSalaryHistories>>>
export type GetAllSalaryHistoriesQueryError = ErrorType<ErrorDetails>


export function useGetAllSalaryHistories<TData = Awaited<ReturnType<typeof getAllSalaryHistories>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSalaryHistories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSalaryHistories>>,
          TError,
          Awaited<ReturnType<typeof getAllSalaryHistories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllSalaryHistories<TData = Awaited<ReturnType<typeof getAllSalaryHistories>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSalaryHistories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSalaryHistories>>,
          TError,
          Awaited<ReturnType<typeof getAllSalaryHistories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllSalaryHistories<TData = Awaited<ReturnType<typeof getAllSalaryHistories>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSalaryHistories>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get salary history for all persons
 */

export function useGetAllSalaryHistories<TData = Awaited<ReturnType<typeof getAllSalaryHistories>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSalaryHistories>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllSalaryHistoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Employment history for current company from personal-data
 * @summary Get company employment history
 */
export const getPersonEmploymentHistory = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonEmploymentPeriodsJSON[]>(
      {url: `/api/v1/rest/persons/employment-history`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonEmploymentHistoryQueryKey = () => {
    return [
    `/api/v1/rest/persons/employment-history`
    ] as const;
    }


export const getGetPersonEmploymentHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonEmploymentHistoryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonEmploymentHistory>>> = ({ signal }) => getPersonEmploymentHistory(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonEmploymentHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonEmploymentHistory>>>
export type GetPersonEmploymentHistoryQueryError = ErrorType<ErrorDetails>


export function useGetPersonEmploymentHistory<TData = Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonEmploymentHistory>>,
          TError,
          Awaited<ReturnType<typeof getPersonEmploymentHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonEmploymentHistory<TData = Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonEmploymentHistory>>,
          TError,
          Awaited<ReturnType<typeof getPersonEmploymentHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonEmploymentHistory<TData = Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get company employment history
 */

export function useGetPersonEmploymentHistory<TData = Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonEmploymentHistory>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonEmploymentHistoryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Employment history for one person from personal-data service
 * @summary Get employment history for a single person
 */
export const getEmploymentHistoryByPerson = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonEmploymentPeriodsJSON>(
      {url: `/api/v1/rest/persons/employment-history/${personId}`, method: 'GET', signal
    },
      options);
    }




export const getGetEmploymentHistoryByPersonQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/persons/employment-history/${personId}`
    ] as const;
    }


export const getGetEmploymentHistoryByPersonQueryOptions = <TData = Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmploymentHistoryByPersonQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>> = ({ signal }) => getEmploymentHistoryByPerson(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmploymentHistoryByPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>>
export type GetEmploymentHistoryByPersonQueryError = ErrorType<ErrorDetails>


export function useGetEmploymentHistoryByPerson<TData = Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>,
          TError,
          Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmploymentHistoryByPerson<TData = Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>,
          TError,
          Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmploymentHistoryByPerson<TData = Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get employment history for a single person
 */

export function useGetEmploymentHistoryByPerson<TData = Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmploymentHistoryByPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmploymentHistoryByPersonQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get all persons with their assigned employee group
 */
export const getPersonsEmployeeGroupSummary = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/persons/employee-groups-summary`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonsEmployeeGroupSummaryQueryKey = () => {
    return [
    `/api/v1/rest/persons/employee-groups-summary`
    ] as const;
    }


export const getGetPersonsEmployeeGroupSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonsEmployeeGroupSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>> = ({ signal }) => getPersonsEmployeeGroupSummary(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonsEmployeeGroupSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>>
export type GetPersonsEmployeeGroupSummaryQueryError = ErrorType<ErrorDetails>


export function useGetPersonsEmployeeGroupSummary<TData = Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>,
          TError,
          Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsEmployeeGroupSummary<TData = Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>,
          TError,
          Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsEmployeeGroupSummary<TData = Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all persons with their assigned employee group
 */

export function useGetPersonsEmployeeGroupSummary<TData = Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsEmployeeGroupSummary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonsEmployeeGroupSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of persons from database
 * @summary Get all persons
 */
export const getAllPersons = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON[]>(
      {url: `/api/v1/rest/persons/all`, method: 'GET', signal
    },
      options);
    }




export const getGetAllPersonsQueryKey = () => {
    return [
    `/api/v1/rest/persons/all`
    ] as const;
    }


export const getGetAllPersonsQueryOptions = <TData = Awaited<ReturnType<typeof getAllPersons>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllPersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPersons>>> = ({ signal }) => getAllPersons(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllPersonsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPersons>>>
export type GetAllPersonsQueryError = ErrorType<ErrorDetails>


export function useGetAllPersons<TData = Awaited<ReturnType<typeof getAllPersons>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPersons>>,
          TError,
          Awaited<ReturnType<typeof getAllPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllPersons<TData = Awaited<ReturnType<typeof getAllPersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPersons>>,
          TError,
          Awaited<ReturnType<typeof getAllPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllPersons<TData = Awaited<ReturnType<typeof getAllPersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all persons
 */

export function useGetAllPersons<TData = Awaited<ReturnType<typeof getAllPersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllPersonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of persons from database that were modified after provided timestamp
 * @summary Get all persons that were modified after provided timestamp
 */
export const getAllPersonsModifiedSince = (
    modifiedSince: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON[]>(
      {url: `/api/v1/rest/persons/all/modified/${modifiedSince}`, method: 'GET', signal
    },
      options);
    }




export const getGetAllPersonsModifiedSinceQueryKey = (modifiedSince: number,) => {
    return [
    `/api/v1/rest/persons/all/modified/${modifiedSince}`
    ] as const;
    }


export const getGetAllPersonsModifiedSinceQueryOptions = <TData = Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError = ErrorType<ErrorDetails>>(modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllPersonsModifiedSinceQueryKey(modifiedSince);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>> = ({ signal }) => getAllPersonsModifiedSince(modifiedSince, requestOptions, signal);





   return  { queryKey, queryFn, enabled: modifiedSince !== null && modifiedSince !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllPersonsModifiedSinceQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>>
export type GetAllPersonsModifiedSinceQueryError = ErrorType<ErrorDetails>


export function useGetAllPersonsModifiedSince<TData = Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPersonsModifiedSince>>,
          TError,
          Awaited<ReturnType<typeof getAllPersonsModifiedSince>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllPersonsModifiedSince<TData = Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPersonsModifiedSince>>,
          TError,
          Awaited<ReturnType<typeof getAllPersonsModifiedSince>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllPersonsModifiedSince<TData = Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all persons that were modified after provided timestamp
 */

export function useGetAllPersonsModifiedSince<TData = Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPersonsModifiedSince>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllPersonsModifiedSinceQueryOptions(modifiedSince,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of person ids without employment end date from database
 * @summary Get all active person ids
 */
export const getActivePersonIds = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<number[]>(
      {url: `/api/v1/rest/persons/activeids`, method: 'GET', signal
    },
      options);
    }




export const getGetActivePersonIdsQueryKey = () => {
    return [
    `/api/v1/rest/persons/activeids`
    ] as const;
    }


export const getGetActivePersonIdsQueryOptions = <TData = Awaited<ReturnType<typeof getActivePersonIds>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersonIds>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivePersonIdsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivePersonIds>>> = ({ signal }) => getActivePersonIds(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivePersonIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivePersonIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getActivePersonIds>>>
export type GetActivePersonIdsQueryError = ErrorType<ErrorDetails>


export function useGetActivePersonIds<TData = Awaited<ReturnType<typeof getActivePersonIds>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersonIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePersonIds>>,
          TError,
          Awaited<ReturnType<typeof getActivePersonIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivePersonIds<TData = Awaited<ReturnType<typeof getActivePersonIds>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersonIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePersonIds>>,
          TError,
          Awaited<ReturnType<typeof getActivePersonIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivePersonIds<TData = Awaited<ReturnType<typeof getActivePersonIds>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersonIds>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all active person ids
 */

export function useGetActivePersonIds<TData = Awaited<ReturnType<typeof getActivePersonIds>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersonIds>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivePersonIdsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of persons without employment end date from database
 * @summary Get all active persons
 */
export const getAllActivePersons = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON[]>(
      {url: `/api/v1/rest/persons/active`, method: 'GET', signal
    },
      options);
    }




export const getGetAllActivePersonsQueryKey = () => {
    return [
    `/api/v1/rest/persons/active`
    ] as const;
    }


export const getGetAllActivePersonsQueryOptions = <TData = Awaited<ReturnType<typeof getAllActivePersons>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActivePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActivePersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActivePersons>>> = ({ signal }) => getAllActivePersons(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllActivePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllActivePersonsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActivePersons>>>
export type GetAllActivePersonsQueryError = ErrorType<ErrorDetails>


export function useGetAllActivePersons<TData = Awaited<ReturnType<typeof getAllActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActivePersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActivePersons>>,
          TError,
          Awaited<ReturnType<typeof getAllActivePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllActivePersons<TData = Awaited<ReturnType<typeof getAllActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActivePersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActivePersons>>,
          TError,
          Awaited<ReturnType<typeof getAllActivePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllActivePersons<TData = Awaited<ReturnType<typeof getAllActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActivePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all active persons
 */

export function useGetAllActivePersons<TData = Awaited<ReturnType<typeof getAllActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActivePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllActivePersonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch specific person from database
 * @summary Get person
 */
export const getPerson = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON>(
      {url: `/api/v1/rest/person/${personId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/person/${personId}`
    ] as const;
    }


export const getGetPersonQueryOptions = <TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonQueryError = ErrorType<unknown>


export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get person
 */

export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Soft deletes person from database
 * @summary Delete person
 */
export const deletePerson = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/person/${personId}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeletePersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,{personId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,{personId: number}, TContext> => {

const mutationKey = ['deletePerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerson>>, {personId: number}> = (props) => {
          const {personId} = props ?? {};

          return  deletePerson(personId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePersonMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerson>>>

    export type DeletePersonMutationError = ErrorType<unknown>

    /**
 * @summary Delete person
 */
export const useDeletePerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,{personId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePerson>>,
        TError,
        {personId: number},
        TContext
      > => {
      return useMutation(getDeletePersonMutationOptions(options), queryClient);
    }
    /**
 * Returns whether the live Procountor `version` for the linked Procountor person is newer than the value last synced to HR. Used before save to warn the user.
 * @summary Check Procountor version drift
 */
export const checkProcountorVersion = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<ProcountorVersionCheckJSON>(
      {url: `/api/v1/rest/person/${personId}/procountor-version-check`, method: 'GET', signal
    },
      options);
    }




export const getCheckProcountorVersionQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/person/${personId}/procountor-version-check`
    ] as const;
    }


export const getCheckProcountorVersionQueryOptions = <TData = Awaited<ReturnType<typeof checkProcountorVersion>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkProcountorVersion>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckProcountorVersionQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkProcountorVersion>>> = ({ signal }) => checkProcountorVersion(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkProcountorVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckProcountorVersionQueryResult = NonNullable<Awaited<ReturnType<typeof checkProcountorVersion>>>
export type CheckProcountorVersionQueryError = ErrorType<ErrorDetails>


export function useCheckProcountorVersion<TData = Awaited<ReturnType<typeof checkProcountorVersion>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkProcountorVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkProcountorVersion>>,
          TError,
          Awaited<ReturnType<typeof checkProcountorVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckProcountorVersion<TData = Awaited<ReturnType<typeof checkProcountorVersion>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkProcountorVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkProcountorVersion>>,
          TError,
          Awaited<ReturnType<typeof checkProcountorVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckProcountorVersion<TData = Awaited<ReturnType<typeof checkProcountorVersion>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkProcountorVersion>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check Procountor version drift
 */

export function useCheckProcountorVersion<TData = Awaited<ReturnType<typeof checkProcountorVersion>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkProcountorVersion>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckProcountorVersionQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch supervisors of given personId
 * @summary Get calendar approvers for given person
 */
export const getApproversByPersonId = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<TeamMemberHRJSON[]>(
      {url: `/api/v1/rest/person/${personId}/approvers`, method: 'GET', signal
    },
      options);
    }




export const getGetApproversByPersonIdQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/person/${personId}/approvers`
    ] as const;
    }


export const getGetApproversByPersonIdQueryOptions = <TData = Awaited<ReturnType<typeof getApproversByPersonId>>, TError = ErrorType<ErrorDetails>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApproversByPersonId>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApproversByPersonIdQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApproversByPersonId>>> = ({ signal }) => getApproversByPersonId(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApproversByPersonId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApproversByPersonIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApproversByPersonId>>>
export type GetApproversByPersonIdQueryError = ErrorType<ErrorDetails>


export function useGetApproversByPersonId<TData = Awaited<ReturnType<typeof getApproversByPersonId>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApproversByPersonId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApproversByPersonId>>,
          TError,
          Awaited<ReturnType<typeof getApproversByPersonId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApproversByPersonId<TData = Awaited<ReturnType<typeof getApproversByPersonId>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApproversByPersonId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApproversByPersonId>>,
          TError,
          Awaited<ReturnType<typeof getApproversByPersonId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApproversByPersonId<TData = Awaited<ReturnType<typeof getApproversByPersonId>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApproversByPersonId>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get calendar approvers for given person
 */

export function useGetApproversByPersonId<TData = Awaited<ReturnType<typeof getApproversByPersonId>>, TError = ErrorType<ErrorDetails>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApproversByPersonId>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApproversByPersonIdQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the person data of logged in user if exists in the database
 * @summary Get person of currently logged in user
 */
export const getCurrentUserPerson = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON>(
      {url: `/api/v1/rest/person/user`, method: 'GET', signal
    },
      options);
    }




export const getGetCurrentUserPersonQueryKey = () => {
    return [
    `/api/v1/rest/person/user`
    ] as const;
    }


export const getGetCurrentUserPersonQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserPerson>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserPersonQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserPerson>>> = ({ signal }) => getCurrentUserPerson(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserPerson>>>
export type GetCurrentUserPersonQueryError = ErrorType<unknown>


export function useGetCurrentUserPerson<TData = Awaited<ReturnType<typeof getCurrentUserPerson>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserPerson>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserPerson<TData = Awaited<ReturnType<typeof getCurrentUserPerson>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserPerson>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserPerson<TData = Awaited<ReturnType<typeof getCurrentUserPerson>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get person of currently logged in user
 */

export function useGetCurrentUserPerson<TData = Awaited<ReturnType<typeof getCurrentUserPerson>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserPerson>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserPersonQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Checks if the provided identifier code already exists
 * @summary Check socSec
 */
export const checkIfSocSecExists = (
    socSec: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<SocSecExistsResultJSON>(
      {url: `/api/v1/rest/person/socsec/check/${socSec}`, method: 'GET', signal
    },
      options);
    }




export const getCheckIfSocSecExistsQueryKey = (socSec: string,) => {
    return [
    `/api/v1/rest/person/socsec/check/${socSec}`
    ] as const;
    }


export const getCheckIfSocSecExistsQueryOptions = <TData = Awaited<ReturnType<typeof checkIfSocSecExists>>, TError = ErrorType<ErrorDetails>>(socSec: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfSocSecExists>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckIfSocSecExistsQueryKey(socSec);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkIfSocSecExists>>> = ({ signal }) => checkIfSocSecExists(socSec, requestOptions, signal);





   return  { queryKey, queryFn, enabled: socSec !== null && socSec !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkIfSocSecExists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckIfSocSecExistsQueryResult = NonNullable<Awaited<ReturnType<typeof checkIfSocSecExists>>>
export type CheckIfSocSecExistsQueryError = ErrorType<ErrorDetails>


export function useCheckIfSocSecExists<TData = Awaited<ReturnType<typeof checkIfSocSecExists>>, TError = ErrorType<ErrorDetails>>(
 socSec: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfSocSecExists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfSocSecExists>>,
          TError,
          Awaited<ReturnType<typeof checkIfSocSecExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfSocSecExists<TData = Awaited<ReturnType<typeof checkIfSocSecExists>>, TError = ErrorType<ErrorDetails>>(
 socSec: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfSocSecExists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfSocSecExists>>,
          TError,
          Awaited<ReturnType<typeof checkIfSocSecExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfSocSecExists<TData = Awaited<ReturnType<typeof checkIfSocSecExists>>, TError = ErrorType<ErrorDetails>>(
 socSec: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfSocSecExists>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check socSec
 */

export function useCheckIfSocSecExists<TData = Awaited<ReturnType<typeof checkIfSocSecExists>>, TError = ErrorType<ErrorDetails>>(
 socSec: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfSocSecExists>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckIfSocSecExistsQueryOptions(socSec,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetches the next available person.nr value
 * @summary Get next available person number
 */
export const getNextPersonNumber = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<number>(
      {url: `/api/v1/rest/person/number`, method: 'GET', signal
    },
      options);
    }




export const getGetNextPersonNumberQueryKey = () => {
    return [
    `/api/v1/rest/person/number`
    ] as const;
    }


export const getGetNextPersonNumberQueryOptions = <TData = Awaited<ReturnType<typeof getNextPersonNumber>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextPersonNumber>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNextPersonNumberQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextPersonNumber>>> = ({ signal }) => getNextPersonNumber(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNextPersonNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNextPersonNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getNextPersonNumber>>>
export type GetNextPersonNumberQueryError = ErrorType<ErrorDetails>


export function useGetNextPersonNumber<TData = Awaited<ReturnType<typeof getNextPersonNumber>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextPersonNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextPersonNumber>>,
          TError,
          Awaited<ReturnType<typeof getNextPersonNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextPersonNumber<TData = Awaited<ReturnType<typeof getNextPersonNumber>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextPersonNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextPersonNumber>>,
          TError,
          Awaited<ReturnType<typeof getNextPersonNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextPersonNumber<TData = Awaited<ReturnType<typeof getNextPersonNumber>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextPersonNumber>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get next available person number
 */

export function useGetNextPersonNumber<TData = Awaited<ReturnType<typeof getNextPersonNumber>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextPersonNumber>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNextPersonNumberQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Checks if the provided person number already exists
 * @summary Check person number
 */
export const checkIfPersonNumberExists = (
    nr: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonNumberExistsResultJSON>(
      {url: `/api/v1/rest/person/number/check/${nr}`, method: 'GET', signal
    },
      options);
    }




export const getCheckIfPersonNumberExistsQueryKey = (nr: number,) => {
    return [
    `/api/v1/rest/person/number/check/${nr}`
    ] as const;
    }


export const getCheckIfPersonNumberExistsQueryOptions = <TData = Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError = ErrorType<ErrorDetails>>(nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckIfPersonNumberExistsQueryKey(nr);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkIfPersonNumberExists>>> = ({ signal }) => checkIfPersonNumberExists(nr, requestOptions, signal);





   return  { queryKey, queryFn, enabled: nr !== null && nr !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckIfPersonNumberExistsQueryResult = NonNullable<Awaited<ReturnType<typeof checkIfPersonNumberExists>>>
export type CheckIfPersonNumberExistsQueryError = ErrorType<ErrorDetails>


export function useCheckIfPersonNumberExists<TData = Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfPersonNumberExists>>,
          TError,
          Awaited<ReturnType<typeof checkIfPersonNumberExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfPersonNumberExists<TData = Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfPersonNumberExists>>,
          TError,
          Awaited<ReturnType<typeof checkIfPersonNumberExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfPersonNumberExists<TData = Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check person number
 */

export function useCheckIfPersonNumberExists<TData = Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfPersonNumberExists>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckIfPersonNumberExistsQueryOptions(nr,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetches person ID by using person number
 * @summary Get person ID from person number
 */
export const getPersonIdFromNumber = (
    nr: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<number>(
      {url: `/api/v1/rest/person/id/number/${nr}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonIdFromNumberQueryKey = (nr: number,) => {
    return [
    `/api/v1/rest/person/id/number/${nr}`
    ] as const;
    }


export const getGetPersonIdFromNumberQueryOptions = <TData = Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError = ErrorType<ErrorDetails>>(nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonIdFromNumberQueryKey(nr);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonIdFromNumber>>> = ({ signal }) => getPersonIdFromNumber(nr, requestOptions, signal);





   return  { queryKey, queryFn, enabled: nr !== null && nr !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonIdFromNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonIdFromNumber>>>
export type GetPersonIdFromNumberQueryError = ErrorType<ErrorDetails>


export function useGetPersonIdFromNumber<TData = Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonIdFromNumber>>,
          TError,
          Awaited<ReturnType<typeof getPersonIdFromNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonIdFromNumber<TData = Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonIdFromNumber>>,
          TError,
          Awaited<ReturnType<typeof getPersonIdFromNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonIdFromNumber<TData = Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get person ID from person number
 */

export function useGetPersonIdFromNumber<TData = Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError = ErrorType<ErrorDetails>>(
 nr: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonIdFromNumber>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonIdFromNumberQueryOptions(nr,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * List persons for import/export
 * @summary List all Procountor and HR persons
 */
export const listProcountor = (
    params?: ListProcountorParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON[]>(
      {url: `/api/v1/rest/list-procountor`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProcountorQueryKey = (params?: ListProcountorParams,) => {
    return [
    `/api/v1/rest/list-procountor`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcountorQueryOptions = <TData = Awaited<ReturnType<typeof listProcountor>>, TError = ErrorType<unknown>>(params?: ListProcountorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcountor>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcountorQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcountor>>> = ({ signal }) => listProcountor(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcountor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcountorQueryResult = NonNullable<Awaited<ReturnType<typeof listProcountor>>>
export type ListProcountorQueryError = ErrorType<unknown>


export function useListProcountor<TData = Awaited<ReturnType<typeof listProcountor>>, TError = ErrorType<unknown>>(
 params: undefined |  ListProcountorParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcountor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcountor>>,
          TError,
          Awaited<ReturnType<typeof listProcountor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcountor<TData = Awaited<ReturnType<typeof listProcountor>>, TError = ErrorType<unknown>>(
 params?: ListProcountorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcountor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcountor>>,
          TError,
          Awaited<ReturnType<typeof listProcountor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcountor<TData = Awaited<ReturnType<typeof listProcountor>>, TError = ErrorType<unknown>>(
 params?: ListProcountorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcountor>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all Procountor and HR persons
 */

export function useListProcountor<TData = Awaited<ReturnType<typeof listProcountor>>, TError = ErrorType<unknown>>(
 params?: ListProcountorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcountor>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcountorQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * List persons for import/export
 * @summary List all Netvisor and HR persons
 */
export const listNetvisor = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonJSON[]>(
      {url: `/api/v1/rest/list-netvisor`, method: 'GET', signal
    },
      options);
    }




export const getListNetvisorQueryKey = () => {
    return [
    `/api/v1/rest/list-netvisor`
    ] as const;
    }


export const getListNetvisorQueryOptions = <TData = Awaited<ReturnType<typeof listNetvisor>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetvisor>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetvisorQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetvisor>>> = ({ signal }) => listNetvisor(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNetvisor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetvisorQueryResult = NonNullable<Awaited<ReturnType<typeof listNetvisor>>>
export type ListNetvisorQueryError = ErrorType<unknown>


export function useListNetvisor<TData = Awaited<ReturnType<typeof listNetvisor>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetvisor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetvisor>>,
          TError,
          Awaited<ReturnType<typeof listNetvisor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetvisor<TData = Awaited<ReturnType<typeof listNetvisor>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetvisor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetvisor>>,
          TError,
          Awaited<ReturnType<typeof listNetvisor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetvisor<TData = Awaited<ReturnType<typeof listNetvisor>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetvisor>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all Netvisor and HR persons
 */

export function useListNetvisor<TData = Awaited<ReturnType<typeof listNetvisor>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetvisor>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetvisorQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Organisational hierarchy in AG Grid format
 * @summary Get company hierarchy
 */
export const getHierarchy = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/hierarchy`, method: 'GET', signal
    },
      options);
    }




export const getGetHierarchyQueryKey = () => {
    return [
    `/api/v1/rest/hierarchy`
    ] as const;
    }


export const getGetHierarchyQueryOptions = <TData = Awaited<ReturnType<typeof getHierarchy>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHierarchy>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHierarchyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHierarchy>>> = ({ signal }) => getHierarchy(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHierarchy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHierarchyQueryResult = NonNullable<Awaited<ReturnType<typeof getHierarchy>>>
export type GetHierarchyQueryError = ErrorType<ErrorDetails>


export function useGetHierarchy<TData = Awaited<ReturnType<typeof getHierarchy>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHierarchy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHierarchy<TData = Awaited<ReturnType<typeof getHierarchy>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHierarchy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHierarchy<TData = Awaited<ReturnType<typeof getHierarchy>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHierarchy>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get company hierarchy
 */

export function useGetHierarchy<TData = Awaited<ReturnType<typeof getHierarchy>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHierarchy>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHierarchyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of employment certificates from database
 * @summary Get all certificates
 */
export const getCertificates = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<EmploymentCertificateJSON[]>(
      {url: `/api/v1/rest/employment-certificates`, method: 'GET', signal
    },
      options);
    }




export const getGetCertificatesQueryKey = () => {
    return [
    `/api/v1/rest/employment-certificates`
    ] as const;
    }


export const getGetCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof getCertificates>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCertificatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCertificates>>> = ({ signal }) => getCertificates(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof getCertificates>>>
export type GetCertificatesQueryError = ErrorType<ErrorDetails>


export function useGetCertificates<TData = Awaited<ReturnType<typeof getCertificates>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCertificates>>,
          TError,
          Awaited<ReturnType<typeof getCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCertificates<TData = Awaited<ReturnType<typeof getCertificates>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCertificates>>,
          TError,
          Awaited<ReturnType<typeof getCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCertificates<TData = Awaited<ReturnType<typeof getCertificates>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all certificates
 */

export function useGetCertificates<TData = Awaited<ReturnType<typeof getCertificates>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCertificatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch specific certificate from database
 * @summary Get certificate
 */
export const getCertificate = (
    id: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<EmploymentCertificateJSON>(
      {url: `/api/v1/rest/employment-certificate/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetCertificateQueryKey = (id: number,) => {
    return [
    `/api/v1/rest/employment-certificate/${id}`
    ] as const;
    }


export const getGetCertificateQueryOptions = <TData = Awaited<ReturnType<typeof getCertificate>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCertificateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCertificate>>> = ({ signal }) => getCertificate(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCertificateQueryResult = NonNullable<Awaited<ReturnType<typeof getCertificate>>>
export type GetCertificateQueryError = ErrorType<unknown>


export function useGetCertificate<TData = Awaited<ReturnType<typeof getCertificate>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCertificate>>,
          TError,
          Awaited<ReturnType<typeof getCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCertificate<TData = Awaited<ReturnType<typeof getCertificate>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCertificate>>,
          TError,
          Awaited<ReturnType<typeof getCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCertificate<TData = Awaited<ReturnType<typeof getCertificate>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get certificate
 */

export function useGetCertificate<TData = Awaited<ReturnType<typeof getCertificate>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCertificateQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Soft deletes a certificate from database
 * @summary Delete certificate
 */
export const deleteCertificate = (
    id: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/employment-certificate/${id}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteCertificateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCertificate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCertificate>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCertificate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCertificate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCertificate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCertificate>>>

    export type DeleteCertificateMutationError = ErrorType<unknown>

    /**
 * @summary Delete certificate
 */
export const useDeleteCertificate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCertificate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCertificate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCertificateMutationOptions(options), queryClient);
    }
    /**
 * Prefill certificate with person and company data
 * @summary Prefill certificate
 */
export const prefillCertificate = (
    personId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<EmploymentCertificateJSON>(
      {url: `/api/v1/rest/employment-certificate/prefill/${personId}`, method: 'GET', signal
    },
      options);
    }




export const getPrefillCertificateQueryKey = (personId: number,) => {
    return [
    `/api/v1/rest/employment-certificate/prefill/${personId}`
    ] as const;
    }


export const getPrefillCertificateQueryOptions = <TData = Awaited<ReturnType<typeof prefillCertificate>>, TError = ErrorType<unknown>>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prefillCertificate>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPrefillCertificateQueryKey(personId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof prefillCertificate>>> = ({ signal }) => prefillCertificate(personId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: personId !== null && personId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prefillCertificate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PrefillCertificateQueryResult = NonNullable<Awaited<ReturnType<typeof prefillCertificate>>>
export type PrefillCertificateQueryError = ErrorType<unknown>


export function usePrefillCertificate<TData = Awaited<ReturnType<typeof prefillCertificate>>, TError = ErrorType<unknown>>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prefillCertificate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prefillCertificate>>,
          TError,
          Awaited<ReturnType<typeof prefillCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePrefillCertificate<TData = Awaited<ReturnType<typeof prefillCertificate>>, TError = ErrorType<unknown>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prefillCertificate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prefillCertificate>>,
          TError,
          Awaited<ReturnType<typeof prefillCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePrefillCertificate<TData = Awaited<ReturnType<typeof prefillCertificate>>, TError = ErrorType<unknown>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prefillCertificate>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Prefill certificate
 */

export function usePrefillCertificate<TData = Awaited<ReturnType<typeof prefillCertificate>>, TError = ErrorType<unknown>>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prefillCertificate>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPrefillCertificateQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch person certificates from database
 * @summary Get person certificates
 */
export const getPersonCertificates = (
    id: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<EmploymentCertificateJSON>(
      {url: `/api/v1/rest/employment-certificate/person/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonCertificatesQueryKey = (id: number,) => {
    return [
    `/api/v1/rest/employment-certificate/person/${id}`
    ] as const;
    }


export const getGetPersonCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof getPersonCertificates>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCertificates>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonCertificatesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonCertificates>>> = ({ signal }) => getPersonCertificates(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonCertificates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonCertificates>>>
export type GetPersonCertificatesQueryError = ErrorType<unknown>


export function useGetPersonCertificates<TData = Awaited<ReturnType<typeof getPersonCertificates>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCertificates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonCertificates>>,
          TError,
          Awaited<ReturnType<typeof getPersonCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCertificates<TData = Awaited<ReturnType<typeof getPersonCertificates>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCertificates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonCertificates>>,
          TError,
          Awaited<ReturnType<typeof getPersonCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCertificates<TData = Awaited<ReturnType<typeof getPersonCertificates>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCertificates>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get person certificates
 */

export function useGetPersonCertificates<TData = Awaited<ReturnType<typeof getPersonCertificates>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCertificates>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonCertificatesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Checks differences from personal-data
 * @summary Check company persons from eSalary
 */
export const comparePersons = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/check-employees`, method: 'GET', signal
    },
      options);
    }




export const getComparePersonsQueryKey = () => {
    return [
    `/api/v1/rest/check-employees`
    ] as const;
    }


export const getComparePersonsQueryOptions = <TData = Awaited<ReturnType<typeof comparePersons>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getComparePersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof comparePersons>>> = ({ signal }) => comparePersons(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof comparePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ComparePersonsQueryResult = NonNullable<Awaited<ReturnType<typeof comparePersons>>>
export type ComparePersonsQueryError = ErrorType<ErrorDetails>


export function useComparePersons<TData = Awaited<ReturnType<typeof comparePersons>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof comparePersons>>,
          TError,
          Awaited<ReturnType<typeof comparePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useComparePersons<TData = Awaited<ReturnType<typeof comparePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof comparePersons>>,
          TError,
          Awaited<ReturnType<typeof comparePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useComparePersons<TData = Awaited<ReturnType<typeof comparePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check company persons from eSalary
 */

export function useComparePersons<TData = Awaited<ReturnType<typeof comparePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComparePersonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Removes a vacation balance entry
 * @summary Delete a vacation balance
 */
export const deleteBalance = (
    balanceId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/vacation-balances/${balanceId}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteBalanceMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBalance>>, TError,{balanceId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBalance>>, TError,{balanceId: number}, TContext> => {

const mutationKey = ['deleteBalance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBalance>>, {balanceId: number}> = (props) => {
          const {balanceId} = props ?? {};

          return  deleteBalance(balanceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBalance>>>

    export type DeleteBalanceMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Delete a vacation balance
 */
export const useDeleteBalance = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBalance>>, TError,{balanceId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBalance>>,
        TError,
        {balanceId: number},
        TContext
      > => {
      return useMutation(getDeleteBalanceMutationOptions(options), queryClient);
    }
